module.exports = __webpack_public_path__ + "static/media/punainen-marc-puristimesta.cab7c17f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/punainen-marc-puristimesta.jpg
 ** module id = 380
 ** module chunks = 0
 **/